import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { ConfirmationService } from 'primeng/api';
import { Store } from '@ngxs/store';
import { IssuerSelectors } from '../pages/issuer/issuer-store/issuer-selectors';
import { ActionsApi } from '../pages/issuer/control-panel/actions/actions-api';

export const confirmLeaveGuard: CanActivateFn = () => {
  const confirmationService = inject(ConfirmationService);
  const store = inject(Store);
  const api = inject(ActionsApi);

  if (store.selectSnapshot(IssuerSelectors.isEditMode)) {
    return new Promise<boolean>(resolve => {
      confirmationService.confirm({
        header: 'Confirm Navigation',
        message: 'You have unsaved changes, do you want to proceed without saving those changes ?',
        accept: () => {
          api.cancelEdit();
          resolve(true);
        },
        reject: () => resolve(false)
      });
    });
  }
  return true;
};
